

// Export for unit testing
import {SETTING_CHANGE_blogExpanded, INITIAL, CALC_OBJECT} from "../actions/types";
import {BLOG_IN_HEADER} from "../actions/types";
import {EXPANDED_IN_HEADER} from "../actions/types";

export const initialState = {
    blogExpanded: [],
    blogExpandedInHead: [],
    handleValue: 0,
    initial:[],
    calc:[]
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SETTING_CHANGE_blogExpanded:
            return {
                ...state,
                blogExpanded: action.payload
            };
        case EXPANDED_IN_HEADER:
            return {
                ...state,
                blogExpandedInHead: action.payload
            };
        case BLOG_IN_HEADER:
            return {
                ...state,
                handleValue : action.payload,
            };
        case INITIAL:
            return {
                ...state,
                initial : action.payload,
            };
        case CALC_OBJECT:
            return {
                ...state,
                calc : action.payload,
            };
        default:
            return state;
    }
};
